export { default } from "./ReportContentForm";
